import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadPatientList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    if (options.organisationId) {
      const result = await axios.get(
        `${baseUrl}/customer/mob/organisations/${
          options.organisationId
        }/patients${params ? `?${params}` : ''}`,
      );
      return result.data;
    }
  },
  loadPatientListForCurrentManage: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    if (options.organisationId) {
      const result = await axios.get(
        `${baseUrl}/customer/mob/organisations/${
          options.organisationId
        }/staffs/${options.staffId}/patients${params ? `?${params}` : ''}`,
      );
      return result.data;
    }
  },

  loadPatientDetail: async options => {
    const result = await axios.get(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/patients/${options.patientId}`,
    );
    return result.data;
  },

  createPatient: async data => {
    const result = await axios.post(
      `${baseUrl}/customer/mob/organisations/${data.organisationId}/patients`,
      data,
    );
    return result.data;
  },

  createPatientCase: async options => {
    const result = await axios.post(
      `${baseUrl}/medicare/mob/organisations/${
        options.organisationId
      }/patients/${options.patientId}/cases`,
      options,
    );
    return result.data;
  },

  updatePatient: async data => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/organisations/${data.organisationId}/patients/${
        data.patient.id
      }`,
      data,
    );
    return result.data;
  },

  updatePatientBilling: async data => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/organisations/${data.organisationId}/patients/${
        data.patient.id
      }/billings`,
      data,
    );
    return result.data;
  },
};
